var _path, _rect, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortaite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 100C2.23858 100 -9.78513e-08 97.7614 -2.18557e-07 95L-1.31134e-06 70L42 70L42 100L5 100Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 65,
    width: 30,
    height: 42,
    transform: "rotate(-90 0 65)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30L-1.09278e-06 5C-1.21349e-06 2.23858 2.23858 -9.78513e-08 5 -2.18557e-07L42 -1.83588e-06L42 30L0 30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 100L57 0L95 -1.66103e-06C97.7614 -1.78174e-06 100 2.23857 100 5L100 95C100 97.7614 97.7614 100 95 100L57 100Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 100,
    height: 6,
    transform: "rotate(90 52 0)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortaite);
export default __webpack_public_path__ + "static/media/portaite.bb8ee9e1ac5ed8739086d9c8605aa344.svg";
export { ForwardRef as ReactComponent };